import React from 'react';
import {
  VertModal,
  VertContainer,
  VertButton,
  Typography
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import Warning from 'components/Concierge/Icons/warning';

const ErrorApiModal = ({ isOpen, onClose, subtitle = "" }) => {
  return (
    <VertModal
      destroyOnClose={true}
      closable={false}
      open={isOpen}
      onCancel={() => onClose()}
      className="modal-text-padding width-modal modal-text-align"
    >
      <Warning className="margin-bottom-divider" />

      <VertContainer className="text-weight-modal-confirmation margin-bottom-divider margin-top-divider">
        <Typography.Title level={2} className='color-title' >
          {`Desculpe, houve um problema no carregamento das informações da página`}
        </Typography.Title>
        <Typography.Text strong className='color-title'>
          {
            !subtitle ?
              <>
                Retorne ao inicio e refaça o processo de nova solicitação do seu produto/serviço.
              </>
              :
              <>
                {subtitle}
              </>
          }
        </Typography.Text>
      </VertContainer>

      <Row className='margin-top-divider width-100' justify={"center"}>
        <Col span={24}>
          <VertButton
            className='width-100 button-concierge'
            type='highlight'
            size="default"
            onClick={() => onClose()}
          >
            Entendi
          </VertButton>
        </Col>
      </Row>
    </VertModal >
  );
};

export default ErrorApiModal;
